if (window.location.host.substr(0, 9) == 'localhost') {
    var basePath = window.location.protocol + "//" + window.location.host + "/chemindesartistes/";
} else {
    var basePath = window.location.protocol + "//" + window.location.host + "/";
}

export {basePath as basePath};


$('body').on('click','#choose-modal-artiste', function (e) {
    e.preventDefault();
    $('#choose-modal').modal('hide');
    $('#artiste-account').modal('show');
})

$('body').on('click','#choose-modal-commune', function (e) {
    e.preventDefault();
    $('#choose-modal').modal('hide');
    $('#commune-account').modal('show');
})


// WEBPACK FOOTER //
// ./src/js/app/global.js